
import { defineComponent, nextTick, onMounted } from "vue";
import { StickyComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "kt-summary",
  components: {},
});
